import { Subject } from 'rxjs';
import { Injectable, Renderer2 } from '@angular/core';

/*
 Service for subscribing on events without rising change detection cycle
 */
@Injectable()
export class FiBrowserEventsService {
    private documentEventSubjects$: {
        [eventName: string]: Subject<Event>;
    } = {};
    private onDocumentEventSubscribed: {
        [eventName: string]: boolean;
    } = {};
    public getDocumentEventSubject$(eventName: string): Subject<Event> {
        if (!this.onDocumentEventSubscribed[eventName]) {
            this.onDocumentEventSubscribed[eventName] = true;
            this.documentEventSubjects$[eventName] = new Subject<Event>();

            document.addEventListener(eventName, (e) => {
                this.documentEventSubjects$[eventName].next(e);
            });
        }
        return this.documentEventSubjects$[eventName];
    }

    private _windowEventSubjects$: {
        [eventName: string]: Subject<Event>;
    } = {};
    private onWindowEventSubscribed: {
        [eventName: string]: boolean;
    } = {};
    public getWindowEventSubject$(eventName: string, options?: boolean | AddEventListenerOptions): Subject<Event> {
        if (!this.onWindowEventSubscribed[eventName]) {
            this.onWindowEventSubscribed[eventName] = true;
            this._windowEventSubjects$[eventName] = new Subject<Event>();

            window.addEventListener(
                eventName,
                (e) => {
                    this._windowEventSubjects$[eventName].next(e);
                },
                options,
            );
        }

        return this._windowEventSubjects$[eventName];
    }
}
